// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'

// === Desktop ===
const DesktopLayout = () => import('../layouts/DesktopLayout.vue')
const DesktopHome = () => import('@desktop/pages/Home.vue')
const DesktopAbout = () => import('@desktop/pages/About.vue')

// === Mobile ===
const MobileLayout = () => import('../layouts/MobileLayout.vue')
const MobileHome = () => import('@mobile/pages/Home.vue')
const MobileAbout = () => import('@mobile/pages/About.vue')

// === Admin ===
const AdminLayout = () => import('../layouts/AdminLayout.vue')
const AdminLogin = () => import('@admin/pages/Login.vue')
const AdminDashboard = () => import('@admin/pages/Dashboard.vue')
const AdminUsers = () => import('@admin/pages/Users.vue')

const routes = [
  // Desktop (default)
  {
    path: '/',
    component: DesktopLayout,
    meta: { theme: 'desktop' },
    children: [
      { path: '', name: 'desktop.home', component: DesktopHome },
      { path: 'about', name: 'desktop.about', component: DesktopAbout },
    ],
  },

  // Mobile
  {
    path: '/m',
    component: MobileLayout,
    meta: { theme: 'mobile' },
    children: [
      { path: '', name: 'mobile.home', component: MobileHome },
      { path: 'about', name: 'mobile.about', component: MobileAbout },
    ],
  },

  // Admin (login ochiq, qolganlari auth bilan)
  {
    path: '/admin',
    component: AdminLayout,
    meta: { theme: 'admin' }, // Eʼtibor bering: endi parent'da requiresAuth yoʻq
    children: [
      { path: 'login', name: 'admin.login', component: AdminLogin, meta: { theme: 'admin' } },
      { path: '', name: 'admin.dashboard', component: AdminDashboard, meta: { theme: 'admin', requiresAuth: true } },
      { path: 'users', name: 'admin.users', component: AdminUsers, meta: { theme: 'admin', requiresAuth: true } },
    ],
  },

  // Qulay redirectlar
  { path: '/home', redirect: { name: 'desktop.home' } },

  // Catch-all
  { path: '/:pathMatch(.*)*', redirect: { name: 'desktop.home' } },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const isAdminRoute = to.meta && to.meta.theme === 'admin'
  const token = localStorage.getItem('token')

  // Admin auth tekshirish: faqat requiresAuth bo'lgan admin child'larda
  if (to.meta && to.meta.requiresAuth && !token) {
    return next({ name: 'admin.login' })
  }

  // Agar admin.login ga token bilan kelsa — dashboardga yuboramiz
  if (to.name === 'admin.login' && token) {
    return next({ name: 'admin.dashboard' })
  }

  // 📱 Kichik ekranlarda avtomatik mobilega yo'naltirish (admin uchun emas)
  if (!isAdminRoute && window.innerWidth <= 768) {
    if (!to.name || !String(to.name).startsWith('mobile')) {
      return next({ name: 'mobile.home' })
    }
  }

  // 💻 Katta ekranlarda avtomatik desktopga yo'naltirish (admin uchun emas)
  if (!isAdminRoute && window.innerWidth > 768) {
    if (!to.name || !String(to.name).startsWith('desktop')) {
      return next({ name: 'desktop.home' })
    }
  }

  // Theme classlarini boshqarish
  const html = document.documentElement
  html.classList.remove('theme-desktop', 'theme-mobile', 'theme-admin')
  if (to.meta && to.meta.theme === 'desktop') html.classList.add('theme-desktop')
  if (to.meta && to.meta.theme === 'mobile') html.classList.add('theme-mobile')
  if (to.meta && to.meta.theme === 'admin') html.classList.add('theme-admin')

  next()
})

export default router
